import { useEffect, useRef, useState } from "react";
import { SampleTransposeKnob } from "../../parameterWidgets/SampleTransposeKnob";
import { ClipControls } from "../../parameterWidgets/ClipControls";
import { PadGrid } from "../../components/PadGrid";
import { SelectorSonsSampler } from "../../parameterWidgets/SelectorSonsLLibreria";
import { PianoRoll } from "../../parameterWidgets/PianoRoll";
import { GrufModulADSR, GrufModulEQ, GrufModulSends } from "../../components/moduls";
import { ParameterKnob } from "../../parameterWidgets/ParameterKnob";
import SeparatorLine from "jsx:$assets/widgets/separator_line.svg";
import { HelpBox } from "../../components/HelpBox";
import { PresetBankBar } from "../../parameterWidgets/PresetBankBar";
import { SamplerWaveform } from "../../parameterWidgets/SamplerWaveform";
import { ParameterToggle } from "../../parameterWidgets/ParameterToggle";
import { useDispatch } from "react-redux";
import { getPadParameterName } from "../../instruments/Sampler";

export const SamplerUI = ({instrument}) => {

    const [selectedPad, setSelectedPad] = useState(0);
    const [arePadsGrouped, setArePadsGrouped] = useState(false);
    const arePadsGroupedRef = useRef();
    arePadsGroupedRef.current = arePadsGrouped;


    const dispatch = useDispatch();
    useEffect(() => {
        const subscriptions = [
            "attack",
            "release",
            // no afegim "start" i "end" perquè podriem fer que un end estigués abans d'un start o viceversa
            "pan",
            "volume",
            "transpose",
            "isReverse",
        ].map(parameterType => {
            const handler = instrument.getParameterHandler(getPadParameterName(selectedPad, parameterType));
            const sideEffect = value => {
                if (!arePadsGroupedRef.current) return;
                Array(16).fill().map((_, i) => i).filter(i => i !== selectedPad).forEach(padIndex => {
                    dispatch(instrument.getParameterHandler(getPadParameterName(padIndex, parameterType)).updater(value));
                })
            }
            return handler.subscribeToUpdate(sideEffect);
        });

        return () => subscriptions.forEach(unsubscribe => unsubscribe());
    }, [selectedPad]);



    return (
        <div className="estacio estacio-sampler" style={{"--accent-color": instrument.metadata.color}}>
            <PresetBankBar instrument={instrument} />
            <div className="col-span-4"/>

            <div className="modul-border modul-bg flex justify-between items-center">
                <ParameterKnob data-widget-id="instrumentVolume" mida="gran" parameterHandler={instrument.getParameterHandler("gain")} />
                <SeparatorLine className="h-full"/>
                <ParameterKnob data-widget-id="lpfCutoff" mida="gran" parameterHandler={instrument.getParameterHandler("lpf_cutoff")} />
            </div>
            <GrufModulEQ className="col-span-2" instrument={instrument}/>
            <GrufModulSends instrument={instrument}/>
            <HelpBox instrument={instrument}/>

            <div className="col-span-2 flex gap-10">
                <SelectorSonsSampler className="flex-auto" instrument={instrument} parameterName={`sound`} transposeSelector={instrument.getParameterHandler(getPadParameterName(selectedPad, "transpose")).selector}/>  {/* sound${selectedPad + 1} if we wanted to control them individually, also need to change instrumentSampler.js*/}
                <ParameterToggle data-widget-id="choke" parameterHandler={instrument.getParameterHandler("choke")} />
            </div>
            <fieldset className="modul-border modul-bg flex gap-10 col-span-3 row-span-2">
                <div className="flex flex-col justify-between">
                    <ParameterKnob data-widget-id="padAttack" mida="petit" parameterHandler={instrument.getParameterHandler(getPadParameterName(selectedPad, "attack"))} />
                    <ParameterKnob data-widget-id="padRelease" mida="petit" parameterHandler={instrument.getParameterHandler(getPadParameterName(selectedPad, "release"))} />
                </div>
                <SamplerWaveform className="flex-auto" instrument={instrument} selectedPad={selectedPad}/>
            </fieldset>
            <fieldset className="modul-border modul-bg flex justify-between items-center col-span-2">
                <ParameterKnob data-widget-id="padPan" mida="petit" parameterHandler={instrument.getParameterHandler(getPadParameterName(selectedPad, "pan"))} />
                <ParameterKnob data-widget-id="padVolume" mida="petit" parameterHandler={instrument.getParameterHandler(getPadParameterName(selectedPad, "volume"))} />
                <SampleTransposeKnob data-widget-id="padTranspose" instrument={instrument} parameterHandler={instrument.getParameterHandler(getPadParameterName(selectedPad, "transpose"))} selectedPad={selectedPad} />
                <ParameterToggle data-widget-id="padReverse" parameterHandler={instrument.getParameterHandler(getPadParameterName(selectedPad, "isReverse"))} />
                <ParameterToggle data-widget-id="padEnvelopeMode" parameterHandler={instrument.getParameterHandler(getPadParameterName(selectedPad, "envelopeMode"))} valueToBool={v => v === "one-shot"} boolToValue={b => b ? "one-shot" : "gated"} label="One-shot"/>
            </fieldset>

            <PadGrid className="row-span-2 col-span-2" instrument={instrument} selectedPad={selectedPad} setSelectedPad={setSelectedPad} arePadsGrouped={arePadsGrouped} setArePadsGrouped={setArePadsGrouped} />
            <PianoRoll className="col-span-3" instrument={instrument} colorNotes={instrument.metadata.color} modeSampler="true"/>
            <ClipControls className="col-span-3 justify-self-end" instrument={instrument} />
            
        </div>
    )
};